import type {Recipe} from './types';

export const besciamellaLeggera: Recipe = {
    id: 25,
    key: "besciamellaLeggera",
    pictures: [
        {index: 0, url: "https://images.fidhouse.com/fidelitynews/wp-content/uploads/sites/6/2014/07/besciamella-32226-2.jpg?width=1600&height=650&quality=80"},
    ],
    video: "https://www.youtube.com/watch?v=eC0p97OdyE0",
    i18n: {
        IT: {
            title: "Besciamella Leggera",
            servings: "1 porzione",
            ingredients: [
                "20 gr di burro (1 noce)",
                "2,5 cucchiai di maizena",
                "400 ml di latte (2 bicchieri)",
            ],
            steps: [
                "Sciogliere il burro in un pentolino a fuoco basso.",
                "Aggiungere la maizena setacciata poco alla volta, mescolando bene per evitare grumi.",
                "Versare lentamente il latte, continuando a mescolare per ottenere una consistenza liscia e cremosa.",
                "Cuocere a fuoco basso, mescolando continuamente, finché la besciamella non si addensa. La consistenza finale dovrebbe essere cremosa, ma leggera.",
                "Togliere dal fuoco e utilizzare subito o coprire con pellicola per evitare la formazione della pellicina in superficie.",
            ],
            notes: "Per un gusto maggiore aggiungere un pizzico di sale e noce moscata verso fine cottura",
        },
        EN: {
            title: "Light Bechamel Sauce",
            servings: "1 serving",
            ingredients: [
                "20 g of butter (1 pat)",
                "2.5 tablespoons of cornstarch",
                "400 ml of milk (2 glasses)",
            ],
            steps: [
                "Melt the butter in a small saucepan over low heat.",
                "Gradually add the sifted cornstarch, stirring well to avoid lumps.",
                "Slowly pour in the milk, stirring constantly to achieve a smooth, creamy texture.",
                "Cook over low heat, stirring continuously, until the bechamel thickens to a light, creamy consistency.",
                "Remove from heat and use immediately, or cover with plastic wrap to prevent a skin from forming on the surface.",
            ],
            notes: "For enhanced flavor, add a pinch of salt and nutmeg towards the end of cooking.",
        },
        PL: {
            title: "Lekki Sos Beszamelowy",
            servings: "1 porcja",
            ingredients: [
                "20 g masła (1 kawałek)",
                "2.5 łyżki mąki kukurydzianej",
                "400 ml mleka (2 szklanki)",
            ],
            steps: [
                "Rozpuścić masło na małym ogniu w rondelku.",
                "Stopniowo dodawać przesianą mąkę kukurydzianą, dobrze mieszając, aby uniknąć grudek.",
                "Powoli wlewać mleko, cały czas mieszając, aby uzyskać gładką, kremową konsystencję.",
                "Gotować na małym ogniu, ciągle mieszając, aż beszamel zgęstnieje do lekkiej, kremowej konsystencji.",
                "Zdjąć z ognia i użyć od razu lub przykryć folią spożywczą, aby zapobiec tworzeniu się skórki na powierzchni.",
            ],
            notes: "Dla lepszego smaku dodaj szczyptę soli i gałki muszkatołowej pod koniec gotowania.",
        },
    },
};
